// UserSidebar.jsx
import React, { useMemo } from "react";
import { faker } from "@faker-js/faker";

export default function UserSidebar({
  onlineUsers,
  onInvite,
  currentGameId,
  busyUserIds = [],
  user,
  setInviteTarget,
  setInviteModalOpen,
}) {
  const realOnline = onlineUsers.filter((u) => u.userId !== user?.uid);

  const fakeUsers = useMemo(() => {
    const need = Math.max(0, 20 - realOnline.length);
    return Array.from({ length: need }, (_, i) => ({
      userId: `bot-${i}-${faker.string.uuid()}`,
      username: faker.internet.userName(),
      avatar: faker.image.avatar(),
      isBot: true,
    }));
  }, [realOnline.length]);

  const combinedUsers = [...realOnline, ...fakeUsers];

  return (
    <aside className="w-full max-w-xs bg-slate-900/95 p-4 rounded-2xl shadow-lg">
      <h3 className="text-lime-400 text-xl font-extrabold mb-3 pl-1">
        Online Players
      </h3>
      <div className="flex flex-col gap-2 max-h-[700px] overflow-y-auto pr-1 custom-scrollbar">
        {combinedUsers.length === 0 && (
          <div className="text-gray-400 italic pl-2">No one online</div>
        )}
        {combinedUsers.map((u) => {
          const isBusy = busyUserIds.includes(u.userId);
          const isBot = u.isBot;

          return (
            <div
              key={u.userId}
              className="flex items-center justify-between bg-slate-800/80 rounded-xl px-3 py-2 gap-3 shadow-sm hover:bg-slate-700 transition-all min-w-0"
            >
              <div className="flex items-center gap-3 min-w-0">
                {u.avatar ? (
                  <img
                    src={u.avatar}
                    alt={u.username}
                    className="w-9 h-9 rounded-full border-2 border-lime-400 object-cover"
                  />
                ) : (
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-orange-500 text-white font-bold text-base border-2 border-lime-400">
                    {u.username?.[0]?.toUpperCase() || "U"}
                  </div>
                )}
                <span
                  className="font-medium text-white truncate max-w-[80px] sm:max-w-[120px]"
                  title={u.username}
                >
                  {u.username.length > 14
                    ? u.username.slice(0, 12) + "…"
                    : u.username}
                </span>
              </div>
              <button
                onClick={() => {
                  if (isBot) {
                    // You can simulate bot behavior or start fake game here
                    setInviteTarget({ ...u, isBot: true });
                    setInviteModalOpen(true);
                  } else {
                    setInviteTarget(u);
                    setInviteModalOpen(true);
                  }
                }}
                className={`font-semibold px-4 py-1 rounded-lg text-xs shadow ml-1
                  ${
                    isBusy
                      ? "bg-gray-400 text-gray-800 cursor-not-allowed"
                      : "bg-lime-400 hover:bg-lime-500 text-slate-900"
                  }
                `}
                disabled={currentGameId || isBusy}
              >
                {isBusy ? "Busy" : "Invite"}
              </button>
            </div>
          );
        })}
      </div>
    </aside>
  );
}
